import { render, staticRenderFns } from "./ConsumeController.vue?vue&type=template&id=59ba1520&"
import script from "./ConsumeController.vue?vue&type=script&lang=ts&"
export * from "./ConsumeController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports